import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';

import SectionList from './SectionList';

export default styled(SectionList)`
  width: 100%;
  margin: 0 auto;
  padding: ${gridSizes('L')} ${gridSizes('L')};
  padding-bottom: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;

  ${media.lessThan('medium')`
  padding: 6px;
`};

  h1 {
    font-size: ${gridSizes('L')};
    font-weight: ${weights('medium')};
  }
  .dateHeader {
    font-weight: ${weights('medium')};
    &:first-letter {
      text-transform: uppercase;
    }
  }
  .scrollableSection {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    padding: 8px;
  }
  .list {
    margin: 0;
    padding: 0;
    list-style: none;

    a {
      text-decoration: none;
    }
  }
`;
